module.exports = __webpack_public_path__ + "static/media/leftIconDE.c2c14cfc.png";